export type InboxRow = { uid: string; email: string };

export type InboxSyncDecision = "reseed" | "mark-pristine" | "keep";

export function newInboxRow(email = ""): InboxRow {
  return { uid: crypto.randomUUID(), email };
}

export function savedInboxEmails(
  emails: string[] | undefined,
  legacy: string | null | undefined,
): string[] {
  if (emails && emails.length > 0) return emails;
  return legacy ? [legacy] : [];
}

export function rowsFromSaved(emails: string[] | undefined, legacy: string | null | undefined): InboxRow[] {
  const saved = savedInboxEmails(emails, legacy);
  return saved.length > 0 ? saved.map((value) => newInboxRow(value)) : [newInboxRow()];
}

export function emailsFromRows(rows: InboxRow[]): string[] {
  return rows.map((row) => row.email.trim()).filter((email) => email.length > 0);
}

export function sameEmails(left: string[], right: string[]): boolean {
  return left.length === right.length && left.every((email, index) => email === right[index]);
}

/** Decide how a settings refetch should interact with in-progress inbox edits. */
export function decideInboxSync(touched: boolean, current: string[], saved: string[]): InboxSyncDecision {
  if (touched) return sameEmails(current, saved) ? "mark-pristine" : "keep";
  return sameEmails(current, saved) ? "keep" : "reseed";
}
